import { render, staticRenderFns } from "./questionCreate.vue?vue&type=template&id=e3a3240e&scoped=true"
import script from "./questionCreate.vue?vue&type=script&lang=js"
export * from "./questionCreate.vue?vue&type=script&lang=js"
import style0 from "./questionCreate.vue?vue&type=style&index=0&id=e3a3240e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a3240e",
  null
  
)

export default component.exports